import { Trans, useLingui } from "@lingui/react/macro";

import {
  BOOKMARK,
  MESSAGE_LENGTH,
  usePokeWithEmoji,
} from "~/hook/overlay/usePokeWithEmoji.ts";
import { createWebDraggableSheet } from "~/ui/base/WebDraggableSheet.tsx";

const Emoji = ({
  emoji,
  focus,
  onClick,
}: {
  emoji: string;
  focus: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      className={`flex h-28 flex-1 items-center justify-center rounded-sm bg-zinc-50 text-5xl dark:bg-zinc-800 ${focus ? "border-b-4 border-black dark:border-white" : ""}`}
      onClick={onClick}
      type="button"
    >
      {emoji}
    </button>
  );
};

export const WebPokeWithEmojiSheet = createWebDraggableSheet<{ email: string }>(
  ({ close, context, titleId }) => {
    const { t } = useLingui();
    const {
      bookmarkPage,
      containerRef,
      data,
      disabled,
      focusIndex,
      handleRemoveEmoji,
      handleScroll,
      handleSelectBookmark,
      handleSelectEmoji,
      handleSend,
      input,
    } = usePokeWithEmoji(context.email, close);

    return (
      <div data-testid="이모티콘 찌르기">
        <h1
          className="text-lg font-semibold text-zinc-800 dark:text-zinc-100"
          id={titleId}
        >
          <Trans>이모티콘 찌르기</Trans> 😊
        </h1>
        <div className="flex gap-2 pt-5">
          {Array.from({ length: MESSAGE_LENGTH }).map((_, index) => (
            <Emoji
              emoji={input[index]}
              focus={index === focusIndex}
              key={`${input[index]}-${String(index)}`}
              onClick={() => {
                handleRemoveEmoji(index);
              }}
            />
          ))}
        </div>
        <div
          className="mt-6 mb-2 flex overflow-x-scroll overflow-y-hidden rounded-full bg-zinc-50 dark:bg-zinc-900"
          style={{ maxHeight: "28px" }}
        >
          {BOOKMARK.map(({ depth, icon, title }, index) => {
            const isVisible = index === bookmarkPage;
            return (
              <button
                className={`flex items-center gap-1 rounded-full px-2 duration-200 ${isVisible ? "scale-110 bg-zinc-100 dark:bg-zinc-800" : ""}`}
                key={icon}
                onClick={() => {
                  handleSelectBookmark(index, depth);
                }}
                type="button"
              >
                <span className="text-xl">{icon}</span>
                {index === bookmarkPage && (
                  <span className="text-xs whitespace-pre text-zinc-700 dark:text-zinc-300">
                    {t(title)}
                  </span>
                )}
              </button>
            );
          })}
        </div>
        <div
          className="overflow-x-scroll"
          onScroll={handleScroll}
          ref={containerRef}
          style={{ height: 204 }}
        >
          <div className="grid grid-flow-col grid-rows-4 gap-1 text-3xl">
            {data?.map((emoji, i) => (
              <button
                className="size-12 rounded-full duration-100 active:scale-90 active:opacity-70"
                key={i}
                onClick={() => {
                  handleSelectEmoji(emoji);
                }}
                type="button"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
        <div className="pt-6">
          <button
            className="h-12 w-full rounded-2xl bg-black font-medium text-white duration-300 active:bg-zinc-300 disabled:bg-zinc-300 dark:bg-zinc-800 dark:active:bg-zinc-700 dark:disabled:bg-zinc-900"
            disabled={disabled}
            onClick={handleSend}
            type="button"
          >
            <Trans>찌르기</Trans> 👉
          </button>
        </div>
      </div>
    );
  },
);
